import { pgTable, text } from 'drizzle-orm/pg-core'
import { relations } from 'drizzle-orm'
import { getBaseFields, getBaseIndexes, getIdReference } from '../common/utils'
import { addresses } from './address'

export const availabilityCheckPoints = pgTable(
  'availability_check_points',
  {
    ...getBaseFields(),
    addressId: getIdReference(() => addresses.id),
    description: text(),
  },
  (table) => getBaseIndexes('availability_check_points', table),
)

export const availabilityCheckPointsRelations = relations(
  availabilityCheckPoints,
  ({ one }) => ({
    address: one(addresses, {
      fields: [availabilityCheckPoints.addressId],
      references: [addresses.id],
    }),
  }),
)
